<script setup lang="ts">

</script>

<template>
  <div class="login-layout">
     <router-view></router-view>
  </div>
</template>

<style scoped>

</style>